// extracted by mini-css-extract-plugin
export default {"MaterialButton":"Button_MaterialButton__rgrPa"};